var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F3F8FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10165_26552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 12.6667H14.3332C13.4127 12.6667 12.6665 13.4129 12.6665 14.3334V21C12.6665 21.9205 13.4127 22.6667 14.3332 22.6667H20.9998C21.9203 22.6667 22.6665 21.9205 22.6665 21V14.3334C22.6665 13.4129 21.9203 12.6667 20.9998 12.6667Z",
    stroke: "#078DE7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3335 12.6666V11C19.3335 10.558 19.1579 10.134 18.8453 9.82147C18.5328 9.50891 18.1089 9.33331 17.6668 9.33331H11.0002C10.5581 9.33331 10.1342 9.50891 9.82165 9.82147C9.50909 10.134 9.3335 10.558 9.3335 11V17.6666C9.3335 18.1087 9.50909 18.5326 9.82165 18.8452C10.1342 19.1577 10.5581 19.3333 11.0002 19.3333H12.6668",
    stroke: "#078DE7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10165_26552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.a195d6a14931f8ddc87682d8740fc793.svg";
export { ForwardRef as ReactComponent };